import { appraisals } from './role'

export const queries = {
  appraisals,
}
export default queries
